import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';

import * as classNames from 'classnames';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions } from 'src/constants/stylesheet';
import FadeInUp from 'src/utils/FadeInUp';

export type PanelTextImageProps =
    React.HTMLAttributes<HTMLElement> &
    {
        dto: PanelTextImageDto,
        text?: string;
        image?: PictureRef;
        legend?: React.ReactNode;
        reverse?: boolean;
    };

const styles = {
    container: {
        ...stylesheet.PaddingGutter(1, directions.top),
        // display: 'flex',
        // [responsive.Mobile]: {
        //     flexDirection: 'column'
        // },
        // [responsive.AfterTablet]: {
        //     paddingTop: spacing.Gutter.Desktop/2
        // }
    },
    title: {
        textAlign: 'center',
        ...stylesheet.PaddingGutter(.15, directions.bottom)
    },
    Subtitle_2: {
        ...stylesheet.Subtitle_2,
    },
    main: {
        display: 'flex',
        [responsive.Mobile]: {
            flexDirection: 'column'
        },
    },
    mainReverse: {
        [responsive.Mobile]: {
            flexDirection: 'column'
        },
        [responsive.AfterMobile]: {
            flexDirection: 'row-reverse'
        }
    },
    text: {
        ...stylesheet.Text,
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [responsive.Mobile]: {
            paddingTop: spacing.Gutter.Mobile,
            paddingLeft: spacing.Gutter.Mobile,
            paddingRight: spacing.Gutter.Mobile
        },
        [responsive.Tablet]: {
            paddingTop: spacing.Gutter.Mobile,
            paddingLeft: spacing.Gutter.Mobile,
            paddingRight: spacing.Gutter.Mobile
        },
        [responsive.AfterTablet]: {
            paddingTop: spacing.Gutter.Desktop / 2,
            paddingLeft: spacing.Gutter.Desktop,
            paddingRight: spacing.Gutter.Desktop
        },
    },
    textInner: {
        ...stylesheet.TextBlocks,
        [responsive.Tablet]: {
            paddingLeft: spacing.Gutter.Mobile / 2,
            paddingRight: spacing.Gutter.Mobile / 2
        },
        [responsive.AfterTablet]: {
            paddingLeft: spacing.Gutter.Desktop / 2,
            paddingRight: spacing.Gutter.Desktop / 2
        },
        '& a': {
            display: 'inline-block',
            position: 'relative',
            borderBottom: '1px solid black',

            '&:hover': {
                borderColor: 'transparent'
            },

            ...stylesheet.Link(false, 'center'),
        }
    },
    image: {
        position: 'relative',
        flex: 1,
        [responsive.Mobile]: {
            paddingTop: spacing.Gutter.Mobile,
            paddingLeft: spacing.Gutter.Mobile,
            paddingRight: spacing.Gutter.Mobile
        },
        [responsive.Tablet]: {
            paddingTop: spacing.Gutter.Mobile,
            paddingLeft: spacing.Gutter.Mobile,
            paddingRight: spacing.Gutter.Mobile
        },
        [responsive.AfterTablet]: {
            paddingTop: spacing.Gutter.Desktop / 2,
            paddingLeft: spacing.Gutter.Desktop,
            paddingRight: spacing.Gutter.Desktop
        },
    },
    imageMobile: {
        [responsive.Mobile]: {
            marginBottom: spacing.Gutter.Mobile
        }
    },
    imageInner: {
        maxWidth: 400,
        margin: '0 auto',
        [responsive.Tablet]: {
            paddingLeft: spacing.Gutter.Mobile / 2,
            paddingRight: spacing.Gutter.Mobile / 2,
        },
        [responsive.AfterTablet]: {
            paddingLeft: spacing.Gutter.Desktop / 2,
            paddingRight: spacing.Gutter.Desktop / 2,
            paddingTop: spacing.Gutter.Desktop,
            marginTop: -spacing.Gutter.Desktop
        },
    },
    figure: {
        position: 'relative',
        height: 0,
    },
    img: {
         position: 'absolute',
        top: 0,
        left: 0,
        maxWidth: '100%',
        maxHeight: '100%'
    },
    figcaption: {
        ...stylesheet.Caption,
        [responsive.BeforeTablet]: {
            paddingTop: 10,
            paddingBottom: 10
        },
        [responsive.AfterTablet]: {
            paddingTop: 20,
            paddingBottom: 20
        },
    },

    figcaptionReverse: {},
};

type Props =
    PanelTextImageProps &
    StyledComponentProps<keyof typeof styles>;

const PanelTextImage: React.FunctionComponent<Props> = (props) => {
    const {
        children,
        classes,
        reverse,
        dto: { Text, Image, Legend, showTitle, Title},
        ...rest
    } = props;

    const imageRatio = `${Image.Height / Image.Width * 100}%`;
    
    return (
        <section
            {...{ ...rest, className: classNames(rest.className, classes!.container) }}
        >
            {showTitle && <FadeInUp>
                {Title && <h2 className={classNames(classes!.title, classes!.Subtitle_2)}>{Title}</h2>}
            </FadeInUp>}
            <div className={classNames(classes!.main, reverse && classes!.mainReverse)}>
                <div className={classNames(classes!.image, classes!.imageMobile)}>
                    {Image &&
                        <figure data-sticky="" className={classes!.imageInner}>
                            <FadeInUp>
                                <div className={classes!.figure} style={{paddingBottom: imageRatio}}>
                                    <img src={Image.Src} className={classes!.img} alt={Image.Legend} />
                                </div>
                                <figcaption
                                    className={classNames(classes!.figcaption)}
                                    dangerouslySetInnerHTML={{ __html: Legend }}
                                />
                            </FadeInUp>
                        </figure>
                    }
                </div>
                <div className={classes!.text}>
                    <FadeInUp>
                        <div className={classes!.textInner} dangerouslySetInnerHTML={{ __html: Text }} />
                    </FadeInUp>
                </div>
            </div>
        </section>
    );
}

export default withStyles(styles)(PanelTextImage);


// WEBPACK FOOTER //
// ./src/components/Panels/PanelTextImage.tsx